<template>
    <div class="pb-3">
        <v-navigation-drawer
            v-model="activityLogDrawer"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card flat class="drawer-content">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Add to Activity Log
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeNavigationDrawer()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                
                <v-card-text class="mt-8">
                    <div class="d-block d-flex justify-space-between align-center">
                        <v-radio-group
                            v-model="log_type"
                            row
                            class="d-inline sansation caption py-0 my-0">
                            <v-radio
                                label="New Note"
                                value="note"
                                color="primary">
                            </v-radio>
                            <v-radio
                                label="Log a Call"
                                value="call"
                                color="success darken-2">
                            </v-radio>
                            <v-radio
                                label="Log an Email"
                                value="email"
                                color="pink darken-4">
                            </v-radio>
                        </v-radio-group>

                        <div class="d-inline d-flex align-center">
                            <v-checkbox
                                v-model="is_checkin"
                                color="accent lighten-1"
                                class="d-inline mt-n6"
                                label="Checking In" 
                                hide-details>
                            </v-checkbox>
                            <template>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="d-inline mt-n5 ml-3">mdi-information</v-icon>
                                    </template>
                                    Check to indicate that this activity log was a way of checking in with the client.
                                </v-tooltip>
                            </template>
                        </div>
                    </div>

                    <div class="d-block align-center mt-4">
                        <WysiwygEditor
                            v-model="formattedManualNote"
                            :toolbar="manualNoteToolbar"
                            rows="10"
                            :label="log_type == 'note' ? 'New Note ...' : log_type == 'call' ? 'Log a Call ...' : log_type == 'email' ? 'Log an Email ...' :''">
                        </WysiwygEditor>
                    </div>
                </v-card-text>

                <v-divider class="mx-4"></v-divider>
                <v-card-actions class="d-flex justify-end mt-3 mx-2">
                    <v-btn 
                        color="primary lighten-2 info--text"
                        class="d-inline"
                        :loading="logging_note"
                        :disabled="logging_note"
                        @click="logManualNote()">
                        {{ log_type == 'note' ? 'Add Note' : log_type == 'call' ? 'Log a Call' : log_type == 'email' ? 'Log an Email' :'' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-navigation-drawer>

        <div class="mb-8 d-block">
            <div class="d-block d-flex justify-end">
                <v-btn 
                    small
                    color="primary"
                    class="mt-1 mb-6"
                    @click="activityLogDrawer = true">
                    Add Log Entry
                </v-btn>
            </div>
            <div class="d-flex d-block justify-space-between">
                <div class="d-inline" style="max-width: 40%; min-width: 40%;">
                    <div class="d-block">
                        <v-text-field 
                            v-model="search"
                            hint="Search a term within the activity logs, or by the name of the user that made the entry."
                            persistent-hint 
                            single-line 
                            color="primary darken-1" 
                            append-icon="mdi-magnify">
                        </v-text-field>
                    </div>
                </div>

                <div class="d-inline" style="max-width: 20%; min-width: 20%">
                    <v-autocomplete 
                        v-model="filterby.log_types"
                        :items="log_types" 
                        label="Log Type(s)" 
                        hide-details 
                        multiple
                        color="primary darken-1"
                        @change="filterLogs()">
                    </v-autocomplete>
                </div>

                <div class="d-inline justify-end" style="max-width: 20%; min-width: 20%;">
                    <!-- Initialized Date Range Picker -->
                    <v-menu
                        ref="initDateMenu"
                        v-model="loggedDateRangeMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="loggedDateRangeText"
                                label="Date Logged Range"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                @click:clear="clearLoggedDateRange"
                                hide-details
                                color="primary darken-1">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filterby.logged_date_range"
                            range
                            no-title
                            scrollable
                            @input="filterby.logged_date_range.length === 2 ? filterLogs() : null"
                        >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="loggedDateRangeMenu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="filterLogs(); loggedDateRangeMenu = false">OK</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
        </div>

        <div v-if="projectActivityReady">
            <div class="d-flex justify-end align-content-center" v-html="filtered_logs_cnt+` logs`"></div>
            
            <v-card
                v-for="log in filteredLogs" 
                :key="log.key"
                class="mt-3 mb-6 pl-4 pr-0 py-0"
                color="#fbfdfd"
                elevation="2">
                
                <div class="d-flex">
                    <div class="d-inline align-stretch mr-6 py-2">
                        <v-btn 
                            fab
                            x-small
                            elevation="0"
                            class="d-inline align-start"
                            :color="log.icon_bg_color">
                            <v-icon :class="log.icon_color">
                                {{ log.icon }}
                            </v-icon>
                        </v-btn>
                    </div>

                    <div class="d-inline align-stretch flex-grow-1 py-2">
                        <div class="d-block d-flex align-center my-1 caption coffee--text text--lighten-1">
                            <div class="d-inline justify-start">
                                <span v-html="log.log_label"></span> {{ log.action_by_name }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon 
                                v-if="log.is_checkin"
                                x-small
                                color="accent lighten-1"
                                class="d-inline mr-2">
                                mdi-comment-check
                            </v-icon>
                            <div class="d-inline justify-end mr-2">
                                {{ formatLogDateTime(log.created_date_time) }}
                            </div>
                        </div>
                        <div class="d-block mt-1 mb-0" v-html="log.activity_log.replace(/\n/g, '<br>')"></div>
                    </div>

                    <a class="d-inline ma-0 delete_forever_link">
                        <v-icon 
                            small
                            style="height: 100%"
                            class="px-1 delete_forever_link"
                            @click="deleteLog(log.key)">
                            mdi-trash-can-outline
                        </v-icon>
                    </a>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    import { safeParseJson } from '../helpers/safe-json';
    import { dataTimeDisplayFormatter } from './utilities';

    import WysiwygEditor from './WysiwygEditor.vue'
    import { quickNotesToolbar } from './shared/editorToolbars'

    export default {
        name: 'ActivityLog',

        components: {
            WysiwygEditor
        },

        props: {
            projectID: String,
            userID: String,
            triggerUserFeedback: Function
        },

        data () {
            return {
                manual_note: '',
                log_type: 'note',
                activityLogDrawer: false,
                is_checkin: false,
                logging_note: false,
                projectActivity: [],
                projectActivityReady: false,
                activity_headers: [
                    {   text: 'Log',     
                        value: 'activity_log',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: 'Action By',     
                        value: 'action_by_name',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: 'Date Created',     
                        value: 'created_date_time',
                        align: 'end',
                        sortable: true 
                    }
                ],
                pin_icon: 'mdi-pin-outline',
                log_types: [
                    { text: 'Auto',  value: 'auto' },
                    { text: 'Call',  value: 'call' },
                    { text: 'Email', value: 'email' },
                    { text: 'Note',  value: 'note' }
                ],
                search: '',
                filterby: {
                    // is_annual: false,
                    // filter_archived: false,
                    // module: [],
                    // status: ['open', 'review', 'processing'],
                    // due_date: [],
                    search: '',
                    log_types: [],
                    logged_date_range: [],
                },
                filteredLogs: [],
                filtered_logs_cnt: 0,
                loggedDateRangeMenu: false,
                manualNoteToolbar: quickNotesToolbar
            }
        },

        computed: {
            loggedDateRangeText () {
                if (!this.filterby.logged_date_range || !this.filterby.logged_date_range.length) return '';
                return this.filterby.logged_date_range.join(' ~ ');
            },

            formattedManualNote: {
                get() {
                    return this.manual_note;
                },
                set(value) {
                    this.manual_note = value;
                }
            },
        },

        watch: {
            search (val) {
                this.filterby.search = val
                this.filterLogs()
                localStorage.setItem('activityLogFilters', JSON.stringify(this.filterby))
            },

            projectID: {
                handler: function ( val ) {
                    this.pullActivityLogs( val )

                    this.logging_note = false
                    this.manual_note = ''
                    this.log_type = 'note'
                },
                deep: true
            },
            
            projectActivityReady (val) {
                if ( !val ) {
                    setTimeout(() => {
                        this.logging_note = false
                        this.manual_note = ''
                        this.log_type = 'note'
                    }, 500)
                }
            }
        },

        created () {
            document.title = `Activity Logs`;

            const savedFilters = localStorage.getItem('activityLogFilters');
            if ( savedFilters ) {
                const parsedFilters = safeParseJson(savedFilters, null)
                if (parsedFilters && typeof parsedFilters === 'object') {
                    this.filterby = parsedFilters
                }
                this.search = this.filterby.search
                this.filterby.log_types = []
                // this.filterby.is_annual = false
                // this.filterby.filter_archived = false
            } else {
                this.setActivityLogSelection()
            }
        },

        mounted () {
            if ( this.projectID ) {
                this.pullActivityLogs( this.projectID )
            }
        },

        methods: {
            formatLogDateTime ( date ) {
                const options = {
                    month: 'short', 
                    day: '2-digit', 
                    year: 'numeric', 
                    hour: 'numeric', 
                    minute: 'numeric', 
                    hour12: true,
                    timeZoneName: 'short'
                }
                return dataTimeDisplayFormatter(date, options)
            },

            closeNavigationDrawer() {
                this.activityLogDrawer = false
            },

            setActivityLogSelection: function () {
                // const admin_modules = this.services.filter(service => this.admin_matches.includes(service.id))
                // this.filterby.module = admin_modules.map(service => service.value)
                // this.filterby.service_levels = ['starter', 'premium', 'elite', 'lite']
                // this.filterby.due_date = []
                // this.filterby.is_annual = false
                // this.filterby.filter_archived = false
                this.filterby.log_types = []
                this.filterby.search = this.search
            },
            
            pullActivityLogs: async function ( project_id ) {
                try {
                    this.projectActivityReady = false
                    const logs_rs = await axios.post(`${appUrls.api}/api/admin/pull_activity`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project_id
                    })

                    if ( logs_rs ) {
                        this.projectActivity = logs_rs.data.activity
                        this.filterLogs()
                        this.projectActivityReady = true
                    }
                
                } catch ( error ) {
                    console.log(error);
                    return false
                }
            },

            filterLogs: function () {
                let filteredLogs = this.projectActivity

                if ( this.filterby.search && this.filterby.search.trim() ) {
                    const searchTerm = this.filterby.search.trim().toLowerCase()

                    filteredLogs = filteredLogs.filter(log => {
                        const activityLogText = (log.activity_log || '').toString().toLowerCase()
                        const actionByNameText = (log.action_by_name || '').toString().toLowerCase()
                        return activityLogText.includes(searchTerm) || actionByNameText.includes(searchTerm)
                    })
                }

                // LEAVING THIS HERE FOR WHEN I NEED TO TEST FILTERING OUT TEST PROJECTS
                // filteredProjects = filteredProjects.filter( prj => !prj.is_test )

                // 1. Filter Archived
                // if (this.filterby.filter_archived) {
                //     filteredProjects = filteredProjects.filter( prj => !prj.is_archived )
                // }

                // 2. Annual Projects Switch
                // const isValuationModule = (this.filterby.module.length && this.doesArrayExist(['valuation-starter', 'valuation-premium', 'valuation-elite'], this.filterby.module)) || !this.filterby.module.length;
                // if (isValuationModule && this.filterby.is_annual) {
                // if ( this.filterby.is_annual ) {
                //     filteredProjects = filteredProjects.filter( prj => prj.is_annual )
                // }

                // 3. Module Filter
                // if (this.filterby.module.length) {
                //     let module_dataset = [].concat.apply([], this.filterby.module);
                //     filteredProjects = filteredProjects.filter( prj => module_dataset.includes(prj.module_key) )
                // }

                // 4. Log Type Filter
                if (this.filterby.log_types.length) {
                    let log_types_dataset = [].concat.apply([], this.filterby.log_types);
                    filteredLogs = filteredLogs.filter( log => log_types_dataset.includes(log.log_type) )
                }

                // 5. Status Filter
                // if (this.filterby.status.length) {
                //     let status_dataset = [].concat.apply([], this.filterby.status);
                //     filteredProjects = filteredProjects.filter( prj => status_dataset.includes(prj.status) )
                // }

                // 6. Existing Due Date Quick Filters
                // if (this.filterby.due_date.length) {
                //     let due_date_dataset = [].concat.apply([], this.filterby.due_date);
                //     filteredProjects = filteredProjects.filter( prj => {
                //         const targetDate = prj.close_date;
                //         return due_date_dataset.some(val => {
                //             if (val === 'past_due') return this.isPastDue(targetDate);
                //             if (val === 'due_today') return this.isToday(targetDate);
                //             if (val === 'due_tomorrow') return this.isTomorrow(targetDate);
                //             if (val === 'due_this_week') return this.isInSameWeek(targetDate);
                //             if (val === 'due_this_month') return this.isSameMonth(targetDate);
                //             return false;
                //         });
                //     });
                // }

                // 7. NEW: Close Date Range Filter
                // if (this.filterby.close_date_range && this.filterby.close_date_range.length === 2) {
                //     // Sort range to ensure [start, end] even if user clicked end date first
                //     const range = [...this.filterby.close_date_range].sort();
                //     const start = new Date(range[0]);
                //     const end = new Date(range[1]);
                //     end.setHours(23, 59, 59, 999); // Include the full end day

                //     filteredProjects = filteredProjects.filter(prj => {
                //         if (!prj.close_date) return false;
                //         const prjDate = new Date(prj.close_date);
                //         return prjDate >= start && prjDate <= end;
                //     });
                // }

                // 8. NEW: Initialized Date Range Filter
                if (this.filterby.logged_date_range && this.filterby.logged_date_range.length === 2) {
                    // Sort range to ensure [start, end] even if user clicked end date first
                    const range = [...this.filterby.logged_date_range].sort();
                    const start = new Date(range[0]);
                    const end = new Date(range[1]);
                    end.setHours(23, 59, 59, 999); // Include the full end day

                    filteredLogs = filteredLogs.filter( log => {
                        if (!log.created_date_time) return false;
                        const logDate = new Date(log.created_date_time);
                        return logDate >= start && logDate <= end;
                    });
                }

                this.filteredLogs = filteredLogs
                this.calculateFilteredLogs(filteredLogs)
            },

            calculateFilteredLogs: async function ( filteredLogs ) {
                this.filtered_logs_cnt = filteredLogs.length
                localStorage.setItem('activityLogFilters', JSON.stringify(this.filterby));
                // this.project_statuses.forEach(status => {
                //     status.count = filteredLogs.filter(p => p.status === status.value).length;
                // });

                // this.project_status_metadata=[]
                // this.project_statuses.forEach( status => {
                //     if ( this.filterby.status.includes(status.value) ) {
                //         this.project_status_metadata.push(`${this.project_statuses.filter( ps => ps.value == status.value )[0].internal_label}: <strong>${status.count}</strong>`)
                //     }
                // })
            },

            clearLoggedDateRange() {
                this.filterby.logged_date_range = [];
                this.filterLogs();
            },

            logManualNote: async function () {
                try {
                    if ( this.manual_note ) {
                        this.projectActivityReady = false
                        const manual_log_rs = await axios.post(`${appUrls.api}/api/admin/log_notes`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            manual_note: this.manual_note,
                            log_type: this.log_type,
                            is_checkin: this.is_checkin,
                            project: { 
                                project_id: this.projectID, 
                                user_id: this.userID 
                            }
                        })

                        if ( manual_log_rs.data.outcome ) {
                            this.closeNavigationDrawer()
                            this.$emit('triggerUserFeedback', true, "Log entry added successfully!", 'success')
                            await this.pullActivityLogs( this.projectID )
                            this.projectActivityReady = true
                        }
                    } else {
                        this.$emit('triggerUserFeedback', true, "Please fill in the field to make an entry!", 'accent')
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            deleteLog: async function ( log_id ) {
                try {
                    this.projectActivityReady = false
                    const manual_log_rs = await axios.post(`${appUrls.api}/api/admin/delete_log`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        log_id: log_id
                    })

                    await this.pullActivityLogs( this.projectID )
                    this.projectActivityReady = true
                    this.$emit('triggerUserFeedback', true, "Log entry deleted successfully!", 'success')
                } catch ( error ) {
                    console.log(error);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .icon-phone {
        /* color: #e8f0d7; */
        color: #fbfdfd;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .delete_forever_link {
        cursor: pointer;
        color: #D9D9D9;
        border-radius: 0 5px 5px 0;
    }
    .delete_forever_link :hover {
        color: orangered;
        background-color: #FCE4EC !important;
        border-radius: 0 5px 5px 0;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/ActivityLogs.vue